import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import styles from './styles.scss';

export const Notification = ({
  message,
  type,
  dismissable,
  active,
  hideNotification,
}) => {
  const classes = {
    [styles['notification']]: true,
    [styles['is-active']]: active,
    [styles['success']]: type === 'success',
    [styles['error']]: type === 'error',
    [styles['warning']]: type === 'warning',
  };
  return (
    <div id="notification" className={classnames([classes])}>
      <div className={styles['notification-wrapper']}>
        {dismissable && (
          <div
            onClick={hideNotification}
            className={styles['notification__close']}
          >
            <svg width="24" height="24" viewBox="0 0 24 24">
              <path
                fill="#FFFFFF"
                d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
              />
              <path d="M0 0h24v24H0z" fill="none" />
            </svg>
          </div>
        )}
        {message}
      </div>
    </div>
  );
};

Notification.propTypes = {
  active: PropTypes.string,
  dismissable: PropTypes.bool,
  hideNotification: PropTypes.func,
  message: PropTypes.string,
  type: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/common/components/Notification/index.js